<template>
  <v-container fluid>
    <BreadHeader :title="'Add Tax Rate (SST)'">
      <v-btn color="#063058" class="white--text" @click="toggleTaxRatePage()">
        <v-icon> mdi-arrow-left </v-icon>
      </v-btn>
    </BreadHeader>

    <AError :api="apiSubmit" />

    <transition name="fade">
      <v-alert
        dense
        border="left"
        type="warning"
        class="text-pre-wrap"
        v-if="alertError.length > 0"
        ><span
          class="d-block"
          v-for="(error, index) in alertError"
          :key="index"
          >{{ error }}</span
        ></v-alert
      >
    </transition>

    <v-dialog v-model="taxRateDialog" max-width="500">
      <v-card>
        <v-card-title class="text-h5"> Add New Tax Rate</v-card-title>

        <v-card-text>
          Please confirm that you wish to Add New Tax Rate ?
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="green lighten-1"
            class="text-light"
            @click="modalClaimApprove()"
          >
            Submit
          </v-btn>

          <v-btn
            color="red lighten-1"
            class="text-light"
            @click="taxRateDialog = false"
          >
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--BOC:[contents]-->
    <v-card>
      <div>
        <!-- Tax Rate -->
        <v-col class="d-flex" cols="12" sm="12" md="6">
          <v-text-field
            dense
            filled
            label="Tax Rate"
            append-icon="mdi-percent"
            v-model="formData.taxRate"
            :error-messages="errorField.taxRate"
          ></v-text-field>
        </v-col>

        <!-- Tax Rate Start Date -->
        <v-col cols="12" sm="6" md="6">
          <v-menu
            ref="menu1"
            v-model="menu1"
            :close-on-content-click="false"
            :return-value.sync="date1"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                dense
                filled
                v-model="formData.taxRateStartDate"
                :error-messages="errorField.taxRateStartDate"
                label="Tax Rate Start Date (YYYY-MM-DD)"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="formData.taxRateStartDate"
              no-title
              scrollable
            >
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="menu1 = false">
                Cancel
              </v-btn>
              <v-btn text color="primary" @click="$refs.menu1.save(date1)">
                OK
              </v-btn>
            </v-date-picker>
          </v-menu>
        </v-col>

        <!-- Tax Rate End Date -->
        <v-col cols="12" sm="6" md="6">
          <v-menu
            ref="menu2"
            v-model="menu2"
            :close-on-content-click="false"
            :return-value.sync="date2"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                dense
                filled
                v-model="formData.taxRateEndDate"
                :error-messages="errorField.taxRateEndDate"
                label="Tax Rate End Date (YYYY-MM-DD)"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="formData.taxRateEndDate"
              no-title
              scrollable
            >
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="menu2 = false">
                Cancel
              </v-btn>
              <v-btn text color="primary" @click="$refs.menu2.save(date2)">
                OK
              </v-btn>
            </v-date-picker>
          </v-menu>
        </v-col>

        <v-col class="d-flex justify-end">
          <v-btn
            class="ma-2"
            color="success"
            @click="taxRateDialog = true"
            :loading="apiSubmit.isLoading"
          >
            Add
          </v-btn>
        </v-col>
      </div>
    </v-card>
    <v-dialog v-model="loadingDialog" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Loading
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
//BOC:[api]
import Api from "@/objects/api";
//EOC
//BOC:[model]
import Model from "@/objects/model";
//EOC
//BOC:[service]
import Service from "@/objects/service";
//EOC
//BOC:[globalData]
import HrdcData from "@/services/hrdc_event/objects/globalData";
//EOC
//BOC:[mapState]
import { mapState } from "vuex";
//EOC

// import moment from "moment";

export default {
  components: {},
  computed: {
    ...mapState({
      auth: (state) => state.auth.data,
    }),
  },
  props: ["params"],
  emits: ["toggleTaxRatePage"],
  data: () => ({
    //BOC:[apiSubmit]
    apiSubmit: new Api(),
    //EOC
    //BOC:[model]
    model: new Model(),
    //EOC
    //BOC:[service]
    service: new Service(),
    //EOC
    //BOC:[hrdcData]
    hrdcData: new HrdcData(),
    //EOC
    alertError: [],
    date1: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .substr(0, 10),
    date2: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .substr(0, 10),
    menu1: false,
    menu2: false,
    formData: {
      applicationNo: null,
      taxRate: null,
      taxRateStartDate: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      taxRateEndDate: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
    },
    errorField: {
      applicationNo: null,
      taxRate: null,
      taxRateStartDate: null,
      taxRateEndDate: null,
    },
    loadingDialog: false,
    taxRateDialog: false,
    editMode: false,
    btnDisabled: false,
  }),
  watch: {
    //
  },
  async created() {
    this.loadingDialog = !this.loadingDialog;
    this.formData.applicationNo = this.$store.state[this.service.key].data.applicationUuid;
    //BOC:[model]
    this.model.getByKey(this.params.modelKey);
    //EOC
    //BOC:[service]
    if (this.model.serviceKey) this.service.set("key", this.model.serviceKey);
    //EOC

    // Assign apiDetails by mapping repository.
    const apiDetails = {
      apiSubmit: {
        url: `${
          this.$service[this.service.key]
        }/v1/en/console/settings/price/create-tax-rate`,
        method: "post",
      },
    };

    for (const api in apiDetails) {
      if (apiDetails[api].url !== undefined) {
        this[api].setUrl(apiDetails[api].url);
      }
      if (apiDetails[api].method !== undefined) {
        this[api].setMethod(apiDetails[api].method);
      }
      if (apiDetails[api].params !== undefined) {
        this[api].setParams(apiDetails[api].params);
      }
    }
    //EOC
    this.stages = await this.hrdcData.allStages;
    this.rolesAssignation(this.auth.roles);
    // if (!this.isTaxpodAdminRoles) {
    //   this.alertError.push("You are not allowed to perform this action!");
    //   this.btnDisabled = true;
    // }

    this.loadingDialog = !this.loadingDialog;
  },
  mounted() {},
  methods: {
    clearErrorMsg() {
      for (let error in this.errorField) {
        this.errorField[error] = null;
      }
    },
    showErrorMessage(response) {
      for (const key in response.data) {
        this.errorField[key] = null;
        this.errorField[key] = response.data[key];
      }
    },
    //EOC
    modalClaimApprove() {
      this.taxRateDialog = !this.taxRateDialog;
      this.submit();
    },
    toggleTaxRatePage() {
      this.$emit("toggleTaxRatePage", "TaxRateIndex");
    },
    redirectBack() {
      let route = this.eventRoute("Application");
      if (this.params.backTo) {
        route = this.params.backTo;
      }

      this.$store.commit("assignDeveloperData", {
        paginationPageNo: this.$route.query.currentPageNo,
      });

      this.$router.push({
        name: route,
        params: {
          modelKey: this.model.key,
          backTo: "",
        },
        query: {
          viewId: this.$store.state[this.service.key].data.viewId,
        },
      });
    },
    async submit() {
      this.loadingDialog = !this.loadingDialog;

      this.apiSubmit.setParams({
        taxRate: this.formData.taxRate,
        taxRateStartDate: this.formData.taxRateStartDate,
        taxRateEndDate: this.formData.taxRateEndDate,
        userUuid: this.auth.uuid,
      });
      this.apiSubmit.fetch();
      this.apiSubmit.setCallbackCompleted((response) => {
        try {
          this.clearErrorMsg();
          if (!response.status) {
            this.showErrorMessage(response);
            this.$store.dispatch("showMessage", {
              message: "Please fill in all the required fields",
              messageType: "error",
              timeout: 2000,
            });
          }

          if (response.status) {
            this.$store.commit("assignDeveloperData", {
              paginationPageNo: this.$route.query.currentPageNo,
            });

            this.$emit("toggleTaxRatePage", "TaxRateIndex");
            this.$store.dispatch("showMessage", {
              message: response.data,
              messageType: "success",
              timeout: 2000,
            });
          }
        } catch (err) {
          console.log(err);
        }
      });
      this.loadingDialog = !this.loadingDialog;
    },
  },
};
</script>
